export default __webpack_public_path__ + "5bf5de8dcd62061f220fb21c1f7710cd.jpg";